import React, { Fragment } from 'react';

const WheelchairPt3 = () => (
  <Fragment>
    <hr />
    <h4>UberWAV vs. UberASSIST</h4>

    <h5>What is UberWAV?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        UberWAV stands for wheelchair accessible vehicle. It's like UberX for people who use a wheelchair who are not
        able to ride in regular vehicles. WAV vehicles allow a person using a wheelchair to remain seated in their
        wheelchair while secured safely.
      </li>
      <li>Is only available in Toronto currently.</li>
      <li>
        Accessible transportation is very limited in Toronto. Uber's goal with UberWAV is to provide a service similar
        to UberX for riders who use wheelchairs. This makes on-demand transportation accessible to more people.
      </li>
      <li>
        Driver partners must have completed accessibility and securement training in order to accept UberWAV trips.
      </li>
    </ul>

    <h5>What is UberASSIST?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        UberASSIST is for riders who may need extra assistance such as the elderly, those with low seeing or hearing and
        people with mobility restrictions. They may use crutches, walkers, canes or foldable wheelchairs.
      </li>
      <li>
        Drivers partners with a sedan who have completed the UberASSIST training are also able to accept UberASSIST
        trips.
      </li>
      <li>
        UberWAV is specifically designed for people who use a wheelchair and can not or prefer not to transfer
        themselves in to a seat of the vehicle. People using a foldable wheelchair however, may book UberASSIST. Their
        wheelchair can be stored in the trunk and they can transfer themselves into a regular seat.
      </li>
      <li>
        Riders who use assistive devices such as canes or crutches should not be requesting WAV trips. They should order
        UberASSIST. Please contact Uber support if they do so the riders can be flagged.
      </li>
    </ul>

    <h5>What is Autzu PLUS?</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        After this training, you are eligible to receive but UberASSIST and UberWAV trips as well as UberX trips.&nbsp;
      </li>
      <li>
        The majority of your trips will still currently be UberX but we expect UberASSIST and UberWAV demand to
        increase.
      </li>
    </ul>
  </Fragment>
);

export default WheelchairPt3;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewWheelchairPt3.js